import MobileTimerControllerPrize from "./components/point-paid";

const MobileTimerControllerPrizePage = () => {
  return <MobileTimerControllerPrize />;
};

export default MobileTimerControllerPrizePage;
